// extracted by mini-css-extract-plugin
export default {"list":"roabfZD1Nm","item":"PBHicuPFzg"};